/**
 * @module common/DualAxis/mixedAxisDefaults
 * @description 组合图 Y 轴 UI 惰性默认值（仅面板展示，未改动不上传）
 */

import { resolveMetricFieldValue } from '../common/DualAxis/axisMetricUtils';
import type { IMixedAxisConfig } from '../common/DualAxis/types';

export const MIXED_DEFAULT_PRIMARY_CHART_TYPE = 'chart-bar';
export const MIXED_DEFAULT_SECONDARY_CHART_TYPE = 'chart-line';

export interface IMixedAxisPair {
  primaryYAxis: IMixedAxisConfig;
  secondYAxis: IMixedAxisConfig;
}

/** base / draft 是否均已持久化主次轴对象 */
export function hasPersistedMixedAxes(
  base: Record<string, unknown>,
  draft: Record<string, unknown>,
): boolean {
  const hasPrimary =
    base.primaryYAxis != null || draft.primaryYAxis != null;
  const hasSecond =
    base.secondYAxis != null || draft.secondYAxis != null;
  return hasPrimary && hasSecond;
}

/** 组合图默认：主 Y 轴 = 第 1 指标 + 柱状；次 Y 轴 = 第 2 指标 + 折线 */
export function buildDefaultMixedAxisPair(
  columnMetrics: unknown[],
): IMixedAxisPair {
  const metrics = columnMetrics as Record<string, unknown>[];
  const firstMetric = metrics[0]
    ? resolveMetricFieldValue(metrics[0])
    : '';
  const secondMetric = metrics[1]
    ? resolveMetricFieldValue(metrics[1])
    : '';

  return {
    primaryYAxis: {
      yAxisName: '',
      metric: firstMetric,
      chartType: MIXED_DEFAULT_PRIMARY_CHART_TYPE,
      yAxisRangeSwitch: false,
    },
    secondYAxis: {
      yAxisName: '',
      metric: secondMetric,
      chartType: MIXED_DEFAULT_SECONDARY_CHART_TYPE,
      yAxisRangeSwitch: false,
    },
  };
}
